import styled from "styled-components";

export const Container = styled.div`
    width: 96%;
    margin: 5rem auto 5rem auto;

    .title{
        display: flex;
        align-items: center;
        margin-bottom: 5rem;

        h2{
            margin-right: 1rem;
            color: #7A05A7;
        }

        div{
            flex: auto;
            height: 1px;
            background: #CCC;
        }
    }
`